module.exports = __webpack_public_path__ + "img/qtfx.1dfa2af6.png";